export enum BotRegion {
  EU_WEST = "eu-west",
  US_EAST = "us-east",
}

export enum AmazonRegion {
  EU_WEST = "eu-west-1",
  US_EAST = "us-east-1",
}
